<template>
  <div class="collection-index">
      <div class="top">
          <img v-if="top_url" :src="top_url" />
      </div>
      <div class="KV">
          <img v-if="banner_url" :src="banner_url" />
      </div>
      <div class="main">
          <img src="@/assets/images/collection/contact_back.png" />
          <p>尊敬的老师，您好<br>
            <br>
            感谢您对本次大会的协助，<br>
            您可以在2023年9月30日之前的任意时间来对您的上报课题进行更新,<br>
            如需要帮助您可以联系会务组。<br>
            <br>
            可扫描下方二维码添加CEC官方客服。<br>
            <img src="@/assets/images/collection/contact_qrcode.jpeg" style="width: 60px;margin: 0 auto;display: block;"/>
            <span style="float:right;">CEC血管论坛会务组</span>
          </p>
          <div class="qrcode">
            <img src="@/assets/images/collection/qrcode_back.png" />
            <img class="qrcode" src="@/assets/images/collection/qrcode.jpeg" />
            <p>长按二维码，关注CEC血管论坛</p>
          </div>
      </div>
      <div class="back" @click="goIndex()">
            <img src="@/assets/images/collection/back_index.png" />
      </div>
  </div>
</template>

<script>
export default {
    data(){
        return{
            id:this.$route.query.id,
            top_url:'',
            banner_url:''

        }
    },
    created(){
        this.getSetting();
        document.title="CEC官方";
        if(common.is_weixin()){
			common.wxShare('课题申报@中国血管论坛CEC2023','上报课题截止时间：2023年9月1日，欢迎您填写您的课题，谢谢您。','cdn.edstatic.com/203012120000/b20d0c68aad9dc88de3d7708dbf6c374/2022/07/9a6c31a0-d2f1-490c-8aa0-5942dc78e9dc.png');
		}

    },
    methods:{
        goIndex(){
            this.$router.push({
				path:'/collection/index',
                query:{
                    id:this.id
                }
			});
        },
         getSetting(){
            const url='webapi/meetings/'+this.id+'/collects';
            //post必填参数，title,content，可选参数code
            let params={};
            const method='GET';
            fetch(url,params,method)
            .then((res)=>{
                if(res.code==0){
                    let data=res.data;
                    this.top_url=data.top_img;
                    this.banner_url=data.banner;
                }
            })
        },

    }

}
</script>

<style lang="scss" scoped>
.collection-index{
    margin-bottom: 60px;
    .top{
        // height: 53px;
        // background-color: #B01C06;
        // padding: 0 15px;
        img{
            width: 100%;
            // height: 31px;
            // vertical-align: middle;
            // margin-top: 11px;
        }
    }
    .KV{
        margin: 15px;
        img{
            width: 100%;
            border-radius: 10px;
        }
    }
    .main{
        margin: 15px;
        position: relative;
        img{
            width: 100%;
        }
        p{
            position: absolute;
            margin: 0 40px;
            top: 24px;
            color: #333333;
            font-size: 12px;
        }
        .qrcode{
            position: absolute;
            bottom:20px;
            text-align: center;
            img{
                width: 60%;
            }
            p{
                position:initial;
                color: white;
            }
            .qrcode{
                    width: 20%;
                    position: absolute;
                    left: 50%;
                    transform: translate(-51%, -15%);
            }
        }
       
    }
    .back{
        position: fixed;
        right: 0;
        bottom: 10px;
        img{
            height: 40px;
        }
    }
}
</style>


// WEBPACK FOOTER //
// src/pages/Contributions/contact.vue